import services from "../service";

export default {
    validate(payload) {
        return services.post('/otp/validate',payload);
    },
    requestOtp(payload){
        return services.post('/otp',payload);
    }
}